import React, { PropTypes } from 'react'

import './AvailabilityCalendarDay.scss'
import TimeSlot from './components/AvailabilityCalendarTimeSlot'
import { LOCALE } from '@src/globals'

export function createTimeSlot ({ selectedDate, onChange }) {
  return (slot) => (
    <TimeSlot
      key={slot.date}
      date={slot.date}
      selected={slot.date.isSame(selectedDate)}
      onClick={onChange}
      available={slot.available}
      />
  )
}

const noAvailabilityMessage = (
  <p className='AvailabilityCalendarDay-dayUnavailable'>
    No
    <br />
    Disponible
  </p>
)

const AvailabilityCalendarDay = (props) => {
  const {
    availability: day,
    selectedDate,
    onChange
  } = props

  const dayLabelFormat = 'ddd D'
  const dayLabel = day.date.locale(LOCALE).format(dayLabelFormat)

  const hasAvailability = day.availability.length
  const timeslots =
    hasAvailability
      ? day.availability.map(createTimeSlot({ selectedDate, onChange }))
      : noAvailabilityMessage

  return (
    <div className='AvailabilityCalendarDay'>
      <p className='AvailabilityCalendarDay-dayLabel'>{ dayLabel }</p>
      <div className='AvailabilityCalendarDay-timeslots'>
        { timeslots }
      </div>
    </div>
  )
}

AvailabilityCalendarDay.displayName = 'AvailabilityCalendarDay'
AvailabilityCalendarDay.propTypes = {
  selectedDate: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  availability: PropTypes.shape({
    date: PropTypes.object.isRequired,
    availability: PropTypes.array.isRequired
  }).isRequired
}

export default AvailabilityCalendarDay



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/AvailabilityCalendarPage/components/AvailabilityCalendarDay/AvailabilityCalendarDay.js